/** Ключ отмены запросов подборки товаров в модалке приза */
export const PRIZE_MODAL_PRODUCTS_ABORT_KEY = 'prize-modal-products-abort-key'
